export const STATIC_ORDER_TYPES = [
    { id: '1', libelle: 'Sur place', type: 'dine_in', isActive: true, icone: 'flaticon-cutlery' },
    { id: '2', libelle: 'Livraison', type: 'delivery', isActive: true, icone: 'flaticon-delivery-truck' },
    { id: '3', libelle: 'A emporter', type: 'click_collect', isActive: true, icone: 'flaticon-take-away' },
];
export const getOrderTypeByCode = (code) => {
    return STATIC_ORDER_TYPES.find(ot => ot.type === code);
};
